import React from 'react';
import ParticipantResultForm from '../../../components/participant/participant-result-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as participantActions from '../../../actions/participant';
import Loading from '../../../components/loading';
import AdminItemPageContainer from '../admin-item-page-container';

class AdminParticipantContainer extends AdminItemPageContainer {

    getBaseUrl() {
        return '/admin/participant-results';
    }

    fetchItem(id) {
        return this.props.actions.fetchParticipantResult(id)
    }

    render() {
        const {actions, loading} = this.props;

        return (
            <div className="panel">
                <header className="panel-header">Participant result edit</header>
                <div className="panel-body">
                    {loading
                        ? <Loading/>
                        : <ParticipantResultForm submit={actions.submitParticipantResult}
                                                 onSuccessSubmit={this.onSuccessSubmit.bind(this)}/>
                    }
                </div>
            </div>
        )

    }
}

export default connect(function (state) {
    return {
        loading: state.admin.participant.participant_result.loading,
        item: state.admin.participant.participant_result.item
    };
}, function (dispatch) {
    return {
        actions: bindActionCreators({
            ...participantActions
        }, dispatch)
    };
})(AdminParticipantContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/participant-results/participant-result-container.js